import { render, staticRenderFns } from "./KidApplicableManagement.vue?vue&type=template&id=83c4b55e&scoped=true"
import script from "./KidApplicableManagement.vue?vue&type=script&lang=js"
export * from "./KidApplicableManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c4b55e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83c4b55e')) {
      api.createRecord('83c4b55e', component.options)
    } else {
      api.reload('83c4b55e', component.options)
    }
    module.hot.accept("./KidApplicableManagement.vue?vue&type=template&id=83c4b55e&scoped=true", function () {
      api.rerender('83c4b55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey_form/component/child_component/KidApplicableManagement.vue"
export default component.exports